document.addEventListener("DOMContentLoaded", () => {
    showCredits();
    setupMobileMenu();
    setupSubmenus();
    setupBackToTop();
    openForm();
});

const MOBILE_BREAKPOINT = 1024;

const toggleForm = (formGroup) => {
    formGroup.classList.toggle('is-open');
};

const openForm = () => {

    document
        .querySelectorAll('.wp-block-button.is-style-form-button')
        .forEach(button => {

            button.addEventListener('click', () => {

                const buttonBlock = button.closest('.wp-block-button');
                const buttonsWrapper = buttonBlock.parentElement;
                let sibling = buttonsWrapper.nextElementSibling;

                while (sibling) {

                    if (
                        sibling.classList.contains('wp-block-group') &&
                        sibling.classList.contains('is-style-hidden-group')
                    ) {
                        toggleForm(sibling);
                        break;
                    }

                    sibling = sibling.nextElementSibling;
                }

            });

        });

    document
        .querySelectorAll('#close-form')
        .forEach(closeButton => {

            closeButton.addEventListener('click', () => {

                const formGroup = closeButton.closest(
                    '.wp-block-group.is-style-hidden-group'
                );

                if (formGroup) {
                    toggleForm(formGroup);
                }

            });

        });

};

const showCredits = () => {
	console.log(
		'%c>XYZZY estudio web_',
		'font-weight: 200; font-size: 30px; color:white; background-color:#ff1a51; padding:40px;'
	);
	console.log( 'Checkout our work on: https://www.xyzzyestudioweb.com' );
};

const setupMobileMenu = () => {
    const hamburgerBtn = document.querySelector(".hamburger-btn");
    const mobileMenu = document.querySelector(".mobile-menu");

    if (!hamburgerBtn || !mobileMenu) {
        return;
    }

    const closeMenu = () => {
        hamburgerBtn.classList.remove("is-active");
        hamburgerBtn.setAttribute("aria-expanded", "false");
        hamburgerBtn.setAttribute("aria-label", "Abrir menú");
        mobileMenu.classList.remove("is-open");
        mobileMenu.setAttribute("aria-hidden", "true");
    };

    const openMenu = () => {
        hamburgerBtn.classList.add("is-active");
        hamburgerBtn.setAttribute("aria-expanded", "true");
        hamburgerBtn.setAttribute("aria-label", "Cerrar menú");
        mobileMenu.classList.add("is-open");
        mobileMenu.setAttribute("aria-hidden", "false");
    };

    hamburgerBtn.addEventListener("click", () => {
        if (window.innerWidth >= MOBILE_BREAKPOINT) {
            closeMenu();
            return;
        }

        if (hamburgerBtn.classList.contains("is-active")) {
            closeMenu();
            return;
        }

        openMenu();
    });

    window.addEventListener("resize", () => {
        if (window.innerWidth >= MOBILE_BREAKPOINT) {
            closeMenu();
        }
    });

    closeMenu();
};

const setupSubmenus = () => {
    const parentItems = document.querySelectorAll(".menu-item-has-children");

    if (!parentItems.length) {
        return;
    }

    const closeAllSubmenus = (exceptItem = null) => {
        parentItems.forEach((item) => {
            if (item === exceptItem) {
                return;
            }

            item.classList.remove("is-submenu-open");

            const trigger = item.querySelector(":scope > a");
            if (trigger) {
                trigger.setAttribute("aria-expanded", "false");
            }
        });
    };

    parentItems.forEach((item, index) => {
        const trigger = item.querySelector(":scope > a");
        const submenu = item.querySelector(":scope > .sub-menu");

        if (!trigger || !submenu) {
            return;
        }

        submenu.id = submenu.id || `submenu-${index + 1}`;
        trigger.setAttribute("aria-expanded", "false");
        trigger.setAttribute("aria-controls", submenu.id);

        trigger.addEventListener("click", (event) => {
            event.preventDefault();

            const isOpen = item.classList.contains("is-submenu-open");

            closeAllSubmenus(item);

            if (isOpen) {
                item.classList.remove("is-submenu-open");
                trigger.setAttribute("aria-expanded", "false");
                return;
            }

            item.classList.add("is-submenu-open");
            trigger.setAttribute("aria-expanded", "true");
        });
    });

    document.addEventListener("click", (event) => {
        if (event.target.closest(".menu-item-has-children")) {
            return;
        }

        closeAllSubmenus();
    });

    window.addEventListener("resize", () => {
        closeAllSubmenus();
    });
};

const setupBackToTop = () => {
    const backTopContainer = document.querySelector(".back-top-container");
    const backToTopButton = document.querySelector(".back-to-top");

    if (!backTopContainer || !backToTopButton) {
        return;
    }

    const toggleVisibility = () => {
        const shouldShow = window.scrollY >= 400;
        backTopContainer.classList.toggle("is-visible", shouldShow);
        backToTopButton.setAttribute("aria-hidden", shouldShow ? "false" : "true");
        backToTopButton.tabIndex = shouldShow ? 0 : -1;
    };

    backToTopButton.addEventListener("click", () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    });

    window.addEventListener("scroll", toggleVisibility, { passive: true });
    toggleVisibility();
};
